
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { ScrollArea } from "@/components/ui/scroll-area";
import { questions } from "./quizQuestions";

interface QuizResultsProps {
  answers: (number | number[])[];
  onClose: () => void;
}

const QuizResults = ({ answers, onClose }: QuizResultsProps) => {
  const calculateScore = (userAnswers: (number | number[])[]) => {
    let totalScore = 0;
    userAnswers.forEach((answer, index) => {
      const correctAnswer = questions[index].correctAnswer;
      if (Array.isArray(correctAnswer) && Array.isArray(answer)) {
        if (correctAnswer.length === answer.length && 
            correctAnswer.every(val => answer.includes(val))) {
          totalScore += 1;
        }
      } else if (!Array.isArray(correctAnswer) && !Array.isArray(answer)) {
        if (answer === correctAnswer) {
          totalScore += 1;
        }
      }
    });
    return totalScore;
  };

  const score = calculateScore(answers);
  const percentage = Math.round((score / questions.length) * 100);

  const getResultMessage = () => {
    if (score >= 17) return "Certified Safe Cook! 🎉";
    if (score >= 14) return "Almost There! Review & Retake.";
    return "Relearn & Retry! Food Safety is Critical.";
  };

  return (
    <ScrollArea className="h-[calc(100vh-300px)] px-4">
      <div className="space-y-6">
        <div className="text-center">
          <p className="text-lg mt-2">
            You got {score} out of {questions.length} correct ({percentage}%)
          </p>
          <p className="text-muted-foreground mt-1">
            {getResultMessage()}
          </p>
        </div>

        <div className="space-y-6">
          {questions.map((question, index) => (
            <Card key={index} className="p-4">
              <div className="space-y-2">
                <h4 className="font-medium">Question {index + 1}</h4>
                <p>{question.text}</p>
                <div className="ml-4">
                  <p className="font-medium">Your answer:</p>
                  <p className={
                    Array.isArray(question.correctAnswer) ?
                      (Array.isArray(answers[index]) &&
                        question.correctAnswer.length === answers[index].length &&
                        question.correctAnswer.every(val => (answers[index] as number[]).includes(val)))
                        ? "text-green-600"
                        : "text-red-600"
                      : answers[index] === question.correctAnswer
                        ? "text-green-600"
                        : "text-red-600"
                  }>
                    {Array.isArray(answers[index])
                      ? (answers[index] as number[]).map(ans => question.options[ans]).join(", ")
                      : question.options[answers[index] as number]
                    }
                  </p>
                  {(Array.isArray(question.correctAnswer)
                    ? !(Array.isArray(answers[index]) &&
                        question.correctAnswer.length === answers[index].length &&
                        question.correctAnswer.every(val => (answers[index] as number[]).includes(val)))
                    : answers[index] !== question.correctAnswer
                  ) && (
                    <p className="text-green-600 mt-1">
                      Correct answer: {Array.isArray(question.correctAnswer)
                        ? question.correctAnswer.map(ans => question.options[ans]).join(", ")
                        : question.options[question.correctAnswer]
                      }
                    </p>
                  )}
                </div>
                <div className="mt-2 p-3 bg-gray-50 rounded-lg">
                  <p className="text-sm">{question.explanation}</p>
                </div>
              </div>
            </Card>
          ))}
        </div>

        <div className="py-4">
          <Button onClick={onClose} className="w-full">
            {score >= 17 ? "Continue" : "Try Again"}
          </Button>
        </div>
      </div>
    </ScrollArea>
  );
};

export default QuizResults;
